// The ≤767 bottom nav (FooterMobile) floats above the viewport bottom plus
// the home-indicator inset — a zone nothing scrolls out of the way: fixed
// surfaces that must stay visible anchor through `aboveBottomNav`, and the
// Footer's ≤767 bottom padding is the pages' clearance. The inset term is 0
// until index.html's viewport meta opts into `viewport-fit=cover`; carrying
// it means that opt-in needs no re-layout here.
const OFFSET = 16;
const HEIGHT = 56;
const SAFE_AREA = 'env(safe-area-inset-bottom, 0px)';

export const bottomNavBottom = `calc(${OFFSET}px + ${SAFE_AREA})`;

export function aboveBottomNav(gutterPx: number): string {
  return `calc(${OFFSET + HEIGHT + gutterPx}px + ${SAFE_AREA})`;
}
